import React from "react";
import { useNavigate } from "react-router";

// Assets
import imgMailSend from "~/assets/img/register-mail-send.png";

import { useTranslation } from "react-i18next";

const JoinAuthMailSend = ({ retryRequest }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<div className="join-auth-mail-wrap">
			<div className="img-wrap">
				<img
					src={imgMailSend}
					alt={t("pages.auth.JoinPage.Contents.JoinAuthMailSend.sendingMail")}
				/>
			</div>
			<h2>{t("pages.auth.JoinPage.Contents.JoinAuthMailSend.sendedMail")}</h2>
			<p>
				{t("pages.auth.JoinPage.Contents.JoinAuthMailSend.completeJoin")}
				<br />
				{t("pages.auth.JoinPage.Contents.JoinAuthMailSend.checkSpam")}
			</p>
			<button
				type="button"
				className="btn__solid btn-confirm"
				color="primary"
				onClick={() => navigate("/")}
			>
				{t("pages.auth.JoinPage.Contents.JoinAuthMailSend.check")}
			</button>
			<div className="mail-resend">
				{t("pages.auth.JoinPage.Contents.JoinAuthMailSend.cantFindEmail")}
				<button className="btn-mail-resend" onClick={retryRequest}>
					{t("pages.auth.JoinPage.Contents.JoinAuthMailSend.retry")}
				</button>
			</div>
		</div>
	);
};

export default JoinAuthMailSend;
